import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
var striptags = require('striptags');

function SuccessMessage(props){
    return(
        <div className="w-full mb-5 p-4 bg-garfield-bg-success grid grid-cols-6 gap-4 justify-items-center items-center">
                <FontAwesomeIcon icon={faCheckCircle} className="text-white self-center" size="2x" aria-hidden="true" />
                <ul className="w-full col-span-2">
                    {props.success.map((data, key) => {
                        let message = data.message? data.message: data
                        return(
                            <li className="w-full col-span-2" key={key}>{striptags(message)}</li>
                        )
                    })}
                </ul>    
        </div>
    )
}

export default SuccessMessage;